<template>
    <div
      :style="[{ backgroundImage: `url(${backgroundImage})` }, { paddingTop: `56.25%` }]"
      class="background-img"
    >
      <p>
        <span v-if="isPlanMatched && subscriberid">{{ $t("Exclusive status") }}</span>
        <span v-else>{{ $t("To enjoy this service, contact to your operator") }}</span>
      </p>
    </div>
  </template>
  
  <script>
    import { eventBus } from "@/eventBus";
    import { mapActions, mapGetters, mapMutations } from "vuex";

    export default {
        data() {
        return {
            isPlanMatched: false,
            backgroundImage: "", // will be set in mounted
            subscriptions: [],
        };
        },
        computed: {
        ...mapGetters(["appConfig", "subscriberid", "subscriptionList"]),
        },
        mounted() {
        this.setBackgroundImage();
    
        if (localStorage.getItem("subscriptionDetails")) {
            this.subscriptionDetails = JSON.parse(localStorage.getItem("subscriptionDetails"));
            this.subscriptions = [...this.subscriptionDetails];
            this.isPlanMatched = this.subscriptions?.find(plan => plan.planid === "QBZGT65Q");
        }
    
        // Listen to resize to update background image dynamically
        window.addEventListener("resize", this.setBackgroundImage);
        },
        beforeDestroy() {
        window.removeEventListener("resize", this.setBackgroundImage);
        },
        methods: {
        setBackgroundImage() {
            const isPortrait = window.innerHeight > window.innerWidth;
            const width = window.innerWidth * window.devicePixelRatio;
    
            let quality = "HD";
            if (width < 400) {
            quality = "THUMBNAIL";
            } else if (width < 720) {
            quality = "LOW";
            } else if (width < 1080) {
            quality = "SD";
            }
    
            const baseURL = `${this.appConfig.urls.hotgoPosterUrl}` || "https://dclkcq4v0w4d8.cloudfront.net/POSTER";
            const imageCode = isPortrait ? this.appConfig.urls.portraitImageCode : this.appConfig.urls.landcapeImageCode;
    
            this.backgroundImage = `${baseURL}/${imageCode}_${quality}.jpg`;
        },
        },
        watch: {
        subscriptionList(val) {
            if (Array.isArray(val) && val.length > 0) {
            this.subscriptions = val;
            this.isPlanMatched = this.subscriptions?.find(plan => plan.planid === "QBZGT65Q");
            }
        },
        },
    };
  </script>
  
  <style lang="scss">
    .background-img {
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 100%;
        height: 100vh;
        position: relative;
    
        p {
        position: absolute;
        bottom: 15%;
        width: 100%;
        display: flex;
        justify-content: center;
    
        span {
            border-radius: 0.5rem;
            padding: 1rem;
            background: rgb(53, 52, 52);
            text-align: center;
        }
        }
    }
  </style>
  